import i18n from '@/i18n';
import axios from 'axios';
import { ROOTPATH } from '../config';
import { urlToParams } from './urlUtil';
import { translateListener } from './translate';
function getCookie(cname) {
  var name = cname + '=';
  var ca = document.cookie.split(';');
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i].trim();
    if (c.indexOf(name) === 0) return c.substring(name.length, c.length);
  }
  return '';
}
const lang = getCookie('lang');
const userAgentInfo = navigator.userAgent.split(' ');
let appid = '1';
userAgentInfo.forEach((item) => {
  if (item.indexOf('miniprogramhtmlwebview') !== -1) {
    appid = '30';
  }
  if (item.indexOf('appName/') !== -1) {
    const spart = item.split('/');
    if (spart[1] === 'ZDClient') {
      appid = '1';
    }
    if (spart[1] === i18n.t('CP Staff')) {
      appid = '2';
    }
  }
  if (item.indexOf('IOrder') !== -1) {
    appid = '1';
  }
  if (item.indexOf('IFarm') !== -1) {
    appid = '2';
  }
});
export default function send(...value) {
  const CLIENTDISTRICT = getCookie('Client-District');
  const urlParam = urlToParams(window.location.search || '');
  const TOKEN =
    getCookie('token') ||
    window.localStorage.getItem('token') ||
    urlParam['token'];
  const zdcmapptype = getCookie('zdcmapptype');
  let config;
  if (typeof value[0] === 'string') {
    config = value[1] || {};
    config.url = value[0];
  } else {
    config = value[0];
  }
  let url = config.url;
  if (url.indexOf('http') !== 0) {
    url = ROOTPATH + url;
  }
  const headers = config.headers || {
    'Content-Type': 'application/json',
    'Client-District': CLIENTDISTRICT,
    Authorization: TOKEN || '',
    'Accept-Language': lang || 'zh',  
    version: getCookie('versionName') || '6.13.4',
    appid,
  };
  if (zdcmapptype) {
    Object.assign(headers, { zdcmapptype });
  }
  return new Promise((resolve, reject) => {
    axios({
      url,
      method: config.method || 'get',
      headers,
      data: config.data,
      withCredentials:
        typeof config.withCredentials === 'undefined'
          ? true
          : config.withCredentials,
      params: Object.assign({ getrandom: Date.now() }, config.params),
      onUploadProgress: config.onProgress,
    })
      .then((res) => {
        if (
          res.data &&
          (res.data.code === 1005 ||
            res.data.code === 1006 ||
            res.data.code === 1007 ||
            res.data.code === 1008 ||
            res.data.code === 1101 ||
            res.data.code === 1100)
        ) {
          const obj = {
            1005: i18n.t('Permission change, new login'),
            1007: i18n.t('account remote login'),
            1008: i18n.t('Login user does not have a matching company'),
            1101: i18n.t('Login expired'),
          };
          reject(obj[res.data.code]);
        } else {
          resolve(res);
          translateListener(url);
        }
      })
      .catch(() => {
        reject(i18n.t('System exception, please try again later!'));
      });
  });
}
